import { useState } from 'react';

// Draft-vs-applied filter state shared by the chip-driven sections (period card,
// graph card). Edits touch `draft`; the query reads `applied`; a query fires only
// when the user presses Apply (or Reset). `hasUnapplied` drives the "Apply *"
// indicator. `makeDefault` must return a fresh object each call (Reset re-seeds
// from it). Dates inside the object serialize stably via JSON, so equality works.
export const useDraftApplied = makeDefault => {
  const [draft, setDraft] = useState(makeDefault);
  const [applied, setApplied] = useState(makeDefault);

  const patch = partial => setDraft(prev => ({ ...prev, ...partial }));
  const apply = () => setApplied(draft);
  const reset = () => {
    const defaults = makeDefault();
    setDraft(defaults);
    setApplied(defaults);
  };
  const hasUnapplied = JSON.stringify(draft) !== JSON.stringify(applied);

  return { draft, applied, patch, apply, reset, hasUnapplied };
};
